export default __webpack_public_path__ + "static/media/DoubleDay12_1280x500.a2810199.jpg";